import { useMutation, useQuery } from "@tanstack/react-query";
import { postStudyAssessmentApiService } from "./postStudyAssessment.api";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statusCode: number;
}

export const usePostStudyAssessmentHook = ({
  studyid,
  subjectno,
}: {
  studyid?: number;
  subjectno?: string | number;
} = {}) => {

  // Insert Vital Signs Mutation
  const InsertVitalSignsMutation = useMutation<
    ApiResponse,
    Error,
    any
  >({
    mutationFn: (payload: any) =>
      postStudyAssessmentApiService.insertVitalSigns(payload),
  });

  // Update Vital Signs Mutation
  const UpdateVitalSignsMutation = useMutation<
    ApiResponse,
    Error,
    any
  >({
    mutationFn: (payload: any) =>
      postStudyAssessmentApiService.updateVitalSigns(payload),
  });

  // Insert Laboratory Assessment Mutation
  const InsertLaboratoryAssessmentMutation = useMutation<
    ApiResponse,
    Error,
    any
  >({
    mutationFn: (payload: any) =>
      postStudyAssessmentApiService.insertLab(payload),
  });

  // Select Assessment Query
  const SelectAssessmentQuery = useQuery({
    queryKey: ["post-study-assessment-select", studyid, subjectno],
    queryFn: () => postStudyAssessmentApiService.selectAssessment(studyid!, subjectno!),
    enabled: !!studyid && !!subjectno,
    staleTime: 0,
  });

  // Verify Assessment Mutation
  const VerifyAssessmentMutation = useMutation<
    ApiResponse,
    Error,
    any
  >({
    mutationFn: (payload: any) =>
      postStudyAssessmentApiService.verifyAssessment(payload),
  });

  // Update Laboratory Assessment Mutation
  const UpdateLaboratoryAssessmentMutation = useMutation<
    ApiResponse,
    Error,
    any
  >({
    mutationFn: (payload: any) =>
      postStudyAssessmentApiService.updateLab(payload),
  });

  return {
    InsertVitalSignsMutation,
    UpdateVitalSignsMutation,
    InsertLaboratoryAssessmentMutation,
    UpdateLaboratoryAssessmentMutation,
    SelectAssessmentQuery,
    VerifyAssessmentMutation,
  };
};
